<template>
  <div class="my-container home pb-2 change">
    <v-app>
      <div class="text-color">
        <div class="py-4 px-6 rounded clearfix">
          <div class="ml-1 golpino-color d-inline-block">
            {{ base_data.name }}
          </div>
          <div class="ml-1 mb-1 text-color d-inline-block">عزیز</div>
          <div class="d-inline-block mb-1">به جمع گل فروشان گلپینو خوش آمدید.</div>
          <div class="left"><a target="_blank" :href="'https://golpino.com/shop/' + base_data.id "><button class="my-button-2">بازدید صفحه {{ base_data.name }}</button></a></div>
        </div>
      </div>
      <div class="text-center d-inline-block back pt-2">
        <div v-if="base_data.status === 3" class="p-2">
          <div class="my-card clearfix notification p-3 pr-0 text-right">
            <div class="right bell-wrapper text-center">
              <div class="d-inline-block">
                <icon-image
                  address="/assets/site/images/seller-icons/bell-purple.svg"
                  classes="mt-1 bell"
                ></icon-image>
                <div class="my-alarm mini">اطلاعیه</div>
              </div>
            </div>
            <div class="notif-text left text-center pt-3">
              <div class="mx-auto text-color normal">
                فروشگاه شما هنوز توسط ادمین تایید نشده است!
              </div>
            </div>
          </div>
        </div>
        <div v-if="no_answer" class="px-1">
          <div class="my-card comments p-3 mb-2 my-text">
            <p class="my-title-3 comment-title mb-1">نظرات جدید</p>
            <div class="mb-3">
              <div class="mb-1 text-right">
                <v-avatar size="38" color="#82c1ff">
                  <span class="icon-user"></span>
                </v-avatar>
                <v-avatar class="user-avatar" size="38" color="#2a86e2">
                  <span class="icon-user"></span>
                </v-avatar>
                <v-avatar class="user-avatar _2" size="38" color="#005ebc">
                  <span class="icon-user"></span>
                </v-avatar>
              </div>
              <div>{{ no_answer }} نظر جدید، از طرف کاربران دارید!</div>
              <!-- <div class="my-text">
              <span> علی، احسان و پدرام... </span>
              <span> نظرات جدید ثبت کرده اند!</span>
            </div> -->
            </div>
            <div class="text-left">
              <router-link :to="'/seller/comments'">
                <button class="btn response">پاسخ دهید</button>
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="monthly" class="pb-6 pt-3 my-card mx-2 charts">
          <div class="mb-5 my-text pb-6">
            <span class="mb-2"> میزان فروش 6 ماهه اخیر </span>
          </div>
          <div class="d-inline-block charts-wrapper my-2">
            <div
              v-for="season in Seasons.slice(0, 6)"
              :key="season"
              class="one-chart mb-1"
            >
              <div class="d-inline-block chart-text align-top ml-1">
                {{ number_separator(season.order_sum) }}
              </div>
              <div class="d-inline-block chart-wrapper">
                <v-progress-linear
                  rounded
                  reverse
                  v-model="season.chart_number"
                  color="light-green darken-1"
                  height="20"
                ></v-progress-linear>
              </div>
              <div class="d-inline-block chart-text align-top mr-1">
                {{ season.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix px-4 my-2">
          <div class="right pt-2 text-color">وضعیت سفارشات</div>
          <div class="left">
            <router-link :to="'/seller/orders'">
              <button class="my-button-2">مشاهده همه</button>
            </router-link>
          </div>
        </div>
        <div class="my-card pt-8 pb-0 my-2 mx-2">
          <div>
            <div class="d-inline-block my-card p-3 m-1 square smaller">
              <div class="my-text mb-3">در حال ارسال</div>
              <h4 class="text-color">{{ status_order.sending }}</h4>
            </div>
            <div class="d-inline-block my-card px-4 pt-8 m-1 square big">
              <div class="my-text mb-3">تحویل شده</div>
              <h4 class="text-color">{{ status_order.received }}</h4>
            </div>
          </div>
          <div>
            <div class="d-inline-block my-card p-4 m-1 square big top-it">
              <div class="my-text mb-3">در حال آماده سازی</div>
              <h4 class="text-color">{{ status_order.in_progress }}</h4>
            </div>
            <div class="d-inline-block my-card p-3 m-1 square smaller">
              <div class="my-text mb-3">قبول شده</div>
              <h4 class="text-color">{{ status_order.accept }}</h4>
            </div>
          </div>
        </div>
        <div class="my-card mb-2 mt-2 mx-2">
          <div class="clearfix banner py-3">
            <div class="fade-back">
              <div class="mb-4 pt-2">
                <span class="d-inline-block mx-1">جایگاه بنر برای </span>
                <h5 class="d-inline-block">گلپینو</h5>
              </div>
              <div class="mb-3">
                <p class="d-inline-block mx-2">متن پیشفرض برای گلپینو</p>
                <button class="btn">کلیک کنید</button>
              </div>
            </div>
            <div class="right small">
              <!-- <img src="../../../../public/img/images/pink-flowers.png" alt=""> -->
            </div>
          </div>
        </div>
        <div class="clearfix px-4 mb-2">
          <div class="right pt-2 text-color">وضعیت مالی</div>
          <div class="left">
            <router-link :to="'/seller/finances'">
              <button class="my-button-2">مشاهده همه</button>
            </router-link>
          </div>
        </div>
        <div class="my-card mx-2 text-color">
          <div class="d-inline-block p-3 my-2">
            <h6>مانده حساب شما (تومان)</h6>
            <div class="text-center mb-2 purple-box">
              {{
                accounting.account_remain
                  ? number_separator(accounting.account_remain)
                  : 0
              }}
            </div>
            <div class="mb-2">
              <div class="d-inline-block align-top text-right">
                <!-- <div class="font pt-1">سفارشات تحویل شده:</div>
                <div class="font pt-1">سفارشات در حال ارسال:</div>
                <div class="font pt-1">سفارشات لغو شده:</div> -->
                <div class="pt-2 font">مجموع سفارشات:</div>
                <div class="pt-2 font">مجموع واریز گلپینو:</div>
              </div>
              <div class="d-inline-block align-top text-left">
                <!-- <div>125000</div>
                <div>123000</div>
                <div>158000</div> -->
                <div class="pt-1 mx-2">
                  {{
                    accounting.order_sum
                      ? number_separator(accounting.order_sum)
                      : 0
                  }}
                </div>
                <div class="pt-1 mx-2">
                  {{
                    accounting.golpino_deposit_sum
                      ? number_separator(accounting.golpino_deposit_sum)
                      : 0
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>
<script>
import { ref, onMounted, watch, computed, inject } from "@vue/composition-api";
import Stat from "./Partials/stat";
import CustomButton from "../Common/customButton";
import DoughnutChart from "./Partials/DoughnutChart";
import IconImage from "../Common/icon";
import Transaction from "./Partials/transaction";
import Recent from "./Partials/recent";
import CustomInput from "../Common/CustomInput";
import LineChart from "./Partials/LineChart.vue";
import Service from "../../../utils/seller-service";
import Resize from "../../../utils/resize";
import axios from "axios";
import global from "../../../state/global";

export default {
  components: {
    Stat,
    CustomButton,
    DoughnutChart,
    Transaction,
    Recent,
    CustomInput,
    IconImage,
    LineChart,
  },
  setup(props, context) {
    (function () {
      if (window.localStorage) {
        if (!localStorage.getItem("firstLoad")) {
          localStorage["firstLoad"] = true;
          window.location.reload();
        } else localStorage.removeItem("firstLoad");
      }
    })();

    function callSupport() {
      // CALL SUPPORT HERE
      console.log("call support");
      this.$emit("newOrder");
    }
    const authService = computed(() => {
      return Service(true);
    });
    const MyResize = computed(() => {
      return Resize(window.innerWidth);
    });
    const products = ref(null);
    const todayOrders = ref([]);
    const lastWeekOrders = ref([]);
    const lastMonthOrders = ref([]);
    const orders = ref(null);
    const transactions = ref(null);
    const accounting = ref(null);
    const global = inject("global");
    const base_data = ref();
    const getProducts = () => {
      authService.value.receive(
        "seller/product",
        {},
        (s, d) => {
          if (s == 200) products.value = d.data;
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/order/status/all",
        {},
        (s, d) => {
          if (s == 200) {
            status_order.value = d.data;
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/order/sell/monthly",
        {},
        (s, d) => {
          if (s == 200) {
            monthly.value = d.data;
            var all_values = [];
            monthly.value.forEach((element, index) => {
              all_values.push(element.order_sum);
            });
            Value100.value = Math.max(...all_values);

            for (let index = 0; index < monthly.value.length; index++) {
              const element = monthly.value[index];
              Seasons.value[element.month - 1].chart_number =
                (element.order_sum / Value100.value) * 100;
              Seasons.value[element.month - 1].order_sum = element.order_sum;
            }
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/order/comment/noanswer",
        {},
        (s, d) => {
          if (s == 200) {
            no_answer.value = d.data;
          }
        },
        (s, e) => {}
      );
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize());
      handleResize();
      var token = window.location.href.toString().split("?token=");
      document.cookie = "cck=1";
      context.root.$router.push("/seller/dashboard").catch(() => {});

      var date1 = new Date("06/30/2019");
      var today = new Date();
      var Difference_In_Time = today.getTime() - date1.getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      console.log(Difference_In_Days);

      authService.value.receive(
        "seller/order",
        {},
        (s, d) => {
          if (s == 200) {
            orders.value = d.data;

            lastWeekOrders.value = [];
            var moment = require("jalali-moment");
            console.log(orders.value.length);
            orders.value.map((p) => {
              if (p.time) {
                p.time2 = moment(
                  p.time.toString().substr(0, 10),
                  "YYYY-MM-DD"
                ).format("MM/DD/YYYY");
                var orderTime = new Date(p.time2);
                var today = new Date();
                var Difference_In_Time = today.getTime() - orderTime.getTime();
                var Difference_In_Days =
                  Difference_In_Time / (1000 * 3600 * 24);
                if (1 < Difference_In_Days < 7) {
                  lastWeekOrders.value.push(p);
                }
                if (Difference_In_Days < 30) {
                  lastMonthOrders.value.push(p);
                }
                if (Difference_In_Days < 1) {
                  todayOrders.value.push(p);
                }
              }
            });
          }
        },
        (s, e) => {
          console.log("this is error", e);
        }
      );

      authService.value.receive(
        "seller/base",
        {},
        (s, d) => {
          if (s == 200) {
            global.user.value.name = d.data.name;
            base_data.value = d.data;

            if (d.data.status != 4) {
              // verified = false
            }
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/accounting/transactions",
        {},
        (s, d) => {
          if (s == 200) {
            transactions.value = d.data;
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/accounting",
        {},
        (s, d) => {
          if (s == 200) {
            accounting.value = d.data;
          }
        },
        (s, e) => {}
      );
      getProducts();
      // unseenProducts.value = orders.length - global.state.value.seenOrders
    });
    const monthly = ref(null);
    const my_width = ref(null);
    const isMobile = ref(null);
    const isDesktop = ref(null);
    const handleResize = () => {
      my_width.value = window.innerWidth;
      if (my_width.value > 700) {
        isMobile.value = false;
        isDesktop.value = true;
      } else {
        isMobile.value = true;
        isDesktop.value = false;
      }
    };
    const status_order = ref(null);
    const no_answer = ref(null);
    const Value100 = ref([]);
    const Seasons = ref([
      {
        id: 1,
        name: "فروردین",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 2,
        name: "اردیبهشت",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 3,
        name: "خرداد",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 4,
        name: "تیر",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 5,
        name: "مرداد",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 6,
        name: "شهریور",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 7,
        name: "مهر",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 8,
        name: "آبان",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 9,
        name: "آذر",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 10,
        name: "دی ",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 11,
        name: "بهمن",
        chart_number: "",
        order_sum: "",
      },
      {
        id: 12,
        name: "اسفند",
        chart_number: "",
        order_sum: "",
      },
    ]);
    const number_separator = (number) => {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    return {
      number_separator,
      Value100,
      Seasons,
      monthly,
      status_order,
      no_answer,
      my_width,
      isMobile,
      isDesktop,
      handleResize,
      products,
      orders,
      global,
      lastWeekOrders,
      lastMonthOrders,
      todayOrders,
      transactions,
      base_data,
      accounting,
      MyResize,
    };
  },
  data() {
    return {
      ghader: 80,
      snackbar: true,
    };
  },
};
</script>
<style lang="scss" scoped>
.my-container {
  &.home {
    max-width: 800px;
  }
}
.back {
  background: #fdfdfd;
}
.notif-prompt {
  background-color: rgba(255, 158, 12, 0.22);
  width: 100%;
  display: block;
  border-radius: 6px;
}

.notif-prompt a {
  color: #772ce8;
  margin: 0px;
  width: 100px;
  float: left;
}

.support-button {
  border: 1px solid #772ce8;
  color: #772ce8;
  background: none;
  font-size: 0.75rem;
  font-weight: lighter;
}

.section-title {
  font-weight: lighter;
  display: inline-block;
}

.chart-col {
  position: relative;
  height: 50vh;
}

.doughChart-container {
  width: 65% !important;
  max-height: 70% !important;
}

.doughChart-stats {
  position: absolute;
  width: 40%;
  left: 0px;
  top: 25%;
  font-size: 0.75rem;
}

.a-chart {
  background-color: #fff;
  padding: 14px 22px 4px 22px;
  width: 100%;
  height: 100%;
}

.lineChart-container {
  height: 90% !important;
}

.transactions {
  padding-right: 2px;
  font-size: 0.9rem;
}

.transactions div {
  background-color: #fff;
}

.recents {
  padding-left: 2px;
  font-size: 0.8rem;
}

.recents div {
  background-color: #fff;
}

.selling-stat {
  height: 40vh;
  overflow: scroll;
  padding-bottom: 15px;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.chart-wrapper {
  width: 65%;
}
.chart-text {
  font-size: 12px;
  width: 16%;
}

.charts-wrapper {
  transform: rotate(-90deg);
  height: 210px;
  padding: 15px 0px;
}
.one-chart {
  width: 280px;
  border-radius: 7px;
  overflow: hidden;
}
.my-card {
  border-radius: 10px;
  // box-shadow: 0 0 5px 1px #fff0fc;
  box-shadow: 0 1px 3px #f2f2f2;
  &.charts {
    min-height: 360px;
  }
}
.icon-user {
  color: white;
}
.user-avatar {
  transform: translate(20px);
  &._2 {
    transform: translate(40px);
  }
  &._3 {
    transform: translate(60px);
  }
}
.btn {
  background: white;
  color: #eb307b;
  padding: 5px 25px;
  font-size: 13px;
  border-radius: 25px;
  font-weight: 400;
  outline: none;
  &.response {
    width: 100%;
    color: #a63cb7;
    background: #dabdee;
    &:hover {
      background: #dba7fc;
      color: #a215b8;
    }
  }
  &:focus {
    outline: none;
  }
  &:hover {
    background: #ff86c2;
    color: white;
  }

  @media (max-width: 600px) {
    width: 90%;
  }
}
.banner {
  background-image: url("../../../../public/img/images/pink-flowers.png");
  background-repeat: no-repeat;
  background-size: contain;
  height: 175px;
  background-position: left;
  width: 100%;
  background-color: #ffccdd;
  color: white;
  border-radius: 10px;
}
.home {
  .my-alarm {
    color: #f07ab9;
  }
  .my-button-2 {
    border-radius: 25px;
    padding: 10px 5px;
    min-width: 130px;
    font-size: 12px;
  }
  .font {
    font-size: 13px;
  }
}
.notification {
  max-width: 400px;
  margin: 0 auto;
}
.bell {
  width: 30px;
}
.bell-wrapper {
  border-left: dashed 2px gray;
  width: 24%;
}
.notif-text {
  width: 74%;
}
.comments {
  background: #fce3ff;
  width: 60%;
  margin: 0 auto;
  @media (max-width: 600px) {
    width: 100%;
  }
}
.my-title-3 {
  &.comment-title {
    color: #815c89;
  }
}
.square {
  width: 130px;
  vertical-align: top;
  background: #fce3ff;
  &.big {
    height: 130px;
    &.top-it {
      transform: translateY(-40px);
    }
  }
  &.smaller {
    height: 90px;
  }
}
.fade-back {
  background-image: linear-gradient(to right, #a86aa2a6, #fc0baf00);
  top: 50%;
  position: relative;
  transform: translateY(-50%);
  padding: 5px 0;
}
.purple-box {
  background: #fce3ff;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 20px;
}
@media (max-width: 600px) {
  .change {
  }
}
</style>